import { Component, OnInit } from '@angular/core';
import { CalendarFilter } from 'src/app/models/CalendarFilter';
import { Student } from 'src/app/models/CalendarModels';
import { CalendarWideFilter } from 'src/app/models/CalendarWideFilter';
import { ContactRow } from 'src/app/models/ContactRow';
import { OptionSet } from 'src/app/models/OptionSet';
import { Schedule } from 'src/app/models/Schedule';
import { ScheduleRow } from 'src/app/models/ScheduleRow';
import { CalendarService } from 'src/app/services/calendar.service';

@Component({
  selector: 'app-class-schedule-list',
  templateUrl: './class-schedule-list.component.html',
  styleUrls: ['./class-schedule-list.component.scss']
})
export class ClassScheduleListComponent implements OnInit {
  scheduleAllRows: ScheduleRow[] = []
  schedulesRows: ScheduleRow[] = [];
  numberOfRows = 0;
  filter: CalendarWideFilter = new CalendarWideFilter();
  dataSource: any;

  constructor(public calendarSvc: CalendarService) {
    this.calendarSvc.classScheduleSubject.subscribe((data: CalendarFilter) => {
      this.loadSchedules(data);
    });

    this.calendarSvc.filterSubject.subscribe((data: CalendarFilter) => {
      this.filterRows(data);
    });
    this.calendarSvc.studentsSubject.subscribe(() => {
      if (this.scheduleAllRows)
        this.scheduleAllRows.forEach(item => {
          let s = this.calendarSvc.classSchedulesList.find(x => x.Id_e == item.Id_e && x.Id_p == item.Id_p);
          item.studentCount = this.countStudents(s.Class, s.ClassCode, s.Classification);
        });
      this.loadSchedules(null);
    });

  }

  ngOnInit() {
    this.loadSchedules(null);
  }

  loadSchedules(callback) {
    //this.calendarSvc.getSchedulesForClasses().then((res: any) => {
    //this.calendarSvc.classSchedulesList = JSON.parse(res);
    this.calendarSvc.classSchedulesListFiltered = this.calendarSvc.classSchedulesList;
    this.schedulesRows = this.calendarSvc.classSchedulesListFiltered.map(x => {
      let item: ScheduleRow = {
        Class: x.Class.viewValue,
        ClassCode: x.ClassCode ? x.ClassCode.viewValue : '',
        Classification: x.Classification ? x.Classification.viewValue : '',
        studentCount: this.countStudents(x.Class, x.ClassCode, x.Classification),
        Sunday: x.Sunday_p ? x.Sunday_p.viewValue : '',
        Monday: x.Monday_p ? x.Monday_p.viewValue : '',
        Tuesday: x.Tuesday_p ? x.Tuesday_p.viewValue : '',
        Wednesday: x.Wednesday_p ? x.Wednesday_p.viewValue : '',
        Thursday: x.Thursday_p ? x.Thursday_p.viewValue : '',
        Friday: x.Friday_p ? x.Friday_p.viewValue : '',
        Saturday: x.Saturday_p ? x.Saturday_p.viewValue : '',
        Year: '',
        Remarks: '',
        Type: '',
        Id_e: x.Id_e,
        Id_p: x.Id_p,
        _checked: false,
        Status: {value:x.Status, viewValue: x.Status},
        ScheduleType: null,
        Index: this.numberOfRows + 1,
        //studentCount: x.studentCount
      };
      this.numberOfRows += 1;
      return item;
    });
    this.allSelected = false;
    this.scheduleAllRows = this.schedulesRows;
    this.dataSource = this.schedulesRows;
    //});
    // if (callback)
    this.filterRows(this.calendarSvc.dataFilter);
    this.calendarSvc.spinnerSubjectEmit(false);

    this.selectedRows = [];
    this.calendarSvc.calendarChosen.next([])
  }

  /**
   * Filter function. another same function at .\..\student-list\student-list.component.ts
   * @param dataFilter filter paramteres
   */
  filterRows(dataFilter: CalendarFilter) {
    if (dataFilter.clearFilter) {
      this.schedulesRows = this.scheduleAllRows;
    }
    else {
      this.schedulesRows = this.scheduleAllRows;
      if (dataFilter.ClassesValues.length > 0) {
        this.schedulesRows = this.schedulesRows.filter(row => {
          return dataFilter.ClassesValues.includes(row.Class)
        })
      }
      // if (dataFilter.ClassesCodesValues.length > 0) {
      //   this.schedulesRows = this.schedulesRows.filter(row => dataFilter.ClassesCodesValues.includes(row.ClassCode))
      // }
      if (dataFilter.ClassAndCode.length > 0) {
        this.schedulesRows = this.schedulesRows.filter(row => dataFilter.ClassAndCode.some(x => x.ClassCode == row.ClassCode));
      }
      if (dataFilter.ClassificationValues.length > 0) {
        this.schedulesRows = this.schedulesRows.filter(row => dataFilter.ClassificationValues.includes(row.Classification))
      }
    }
    this.dataSource = this.schedulesRows;
  }


  onSelectRow(scdl: ScheduleRow) {
    if (scdl._checked) {
      this.selectedRows.push(scdl);
      if (this.selectedRows.length == this.schedulesRows.length)
        this.allSelected = true;
      if(scdl.Status.value != 'ממתין לביטול'){
        this.waitFotCancelSelected++;
      }
    }
    else {
      let i: number;
      i = this.GetScheduleSelectedIndex(scdl);
      this.selectedRows.splice(i, 1);
      this.allSelected = false;
      if(scdl.Status.value != 'ממתין לביטול'){
        this.waitFotCancelSelected--;
      }
    
    }

    this.calendarSvc.filterCalendarWidely(this.selectedRows);
    if(this.waitFotCancelSelected == 0)
      this.calendarSvc.calendarChosen.next([]);
    else
      this.calendarSvc.calendarChosen.next(this.selectedRows);

  }
  GetScheduleSelectedIndex(scdl: ScheduleRow): number {
    return this.selectedRows.findIndex(s => s.Index == scdl.Index); //לבדוק אם זה התנאי הנכון
  }

  public selectedRows: Array<ScheduleRow> = new Array<ScheduleRow>();
  public waitFotCancelSelected : number = 0;
  public allSelected: boolean = false;
  selectAllRows() {
    if (this.allSelected) {
      this.schedulesRows.forEach(row => {
        row._checked = false;
      });
      this.allSelected = false;
      this.selectedRows = [];
      this.waitFotCancelSelected = 0;
    }
    else {
      this.schedulesRows.forEach(row => {
        row._checked = true;
        if(row.Status.value != 'ממתין לביטול')
          this.waitFotCancelSelected++;
      })
      this.allSelected = true;
      this.selectedRows = this.schedulesRows.filter(x => true);
    }
    if(this.waitFotCancelSelected == 0)
      this.calendarSvc.calendarChosen.next([]);
    else
      this.calendarSvc.calendarChosen.next(this.selectedRows);
    this.calendarSvc.filterCalendarWidely(this.selectedRows);
  }

  unSelectAll() {
    this.allSelected = true;
    this.selectAllRows();
  }

  pageOfItems: Array<any>;

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  countStudents(_class: OptionSet, _classcode: OptionSet, _classification: OptionSet) {
    let res: Student[] = [];
    if (_class.viewValue == 'צהרון') {
      res = this.calendarSvc.studentsList.filter(stdnt => stdnt.AfternoonIdentifier && stdnt.AfternoonIdentifier == this.calendarSvc.dataService.userModel.InstitutionNumber);
    }
    else {
      res = this.calendarSvc.studentsList.filter(x => x.Class?.value == _class.value);

      if (_classcode) {
        res = res.filter(x => x.ClassCode?.viewValue == _classcode.viewValue);
      }
      else {
        res = res.filter(x => !x.ClassCode);
      }
      if (_classification) {
        res = res.filter(x => x.Classification?.viewValue == _classification.viewValue);
      }
    }
    return res.length;
  }
}
